<template>
  <div>
    <div>
      <!-- <el-button class="operator-btn" type="primary"
        >打开录音,请求权限</el-button
      > -->
      <img style="width: 35px;height: 35px;cursor: pointer;" src="@/statics/imgs/ly.png" alt="" @click="recOpen">
      <!-- <el-button class="operator-btn" type="primary" @click="recStart">开始录音</el-button>
      <el-button class="operator-btn" type="primary" @click="recStop">结束录音</el-button> -->
      <!-- <el-button class="operator-btn" type="primary" @click="recPlay"
        >本地试听</el-button
      > -->
      <!-- <el-button class="operator-btn" type="primary" @click="recClear"
        >删除录音</el-button
      > -->
      <!-- </div>
    <P class="localUrl-block" v-if="recBlob">{{ localUrl
    }}<i class="el-icon-error localUrl-block-icon" @click="recClear"></i></P>
    <div style="padding-top: 5px" :style="{
      opacity: waveBlock ? 1 : 0,
    }"> -->
      <!-- 波形绘制区域 -->
      <!-- <div style="
          border: 1px solid #ccc;
          display: inline-block;
          vertical-align: bottom;
        ">
        <div style="height: 100px; width: 300px" ref="recwave"></div>
      </div> -->
    </div>
    <el-dialog title="录音" :visible.sync="dialogVisible" width="20%" :modal='false' :modal-append-to-body="false" center
      :before-close="handleClose">
      <div style="text-align: center;" v-if="dielfds">
        <img style="width: 35px;height: 35px;cursor: pointer;" src="@/statics/imgs/ly.png" alt="" @click="recStart">
        <div style="font-size: 14px;color: #aaa;line-height: normal;">
          点击开始录音
        </div>
      </div>
      <div v-else style="text-align: center;">
        <img @click="recStop" style="width: 56px;height: 56px;cursor: pointer;"
          src="https://files.axshare.com/gsc/6RTH8X/e6/56/0c/e6560c317a484ee5b1fd335a49cd1969/images/a预约列表/停止图片_u352.png?pageId=374672ad-6717-4f33-bd50-ec8d79948268"
          alt="">
        <div style="font-size: 14px;color: #aaa;line-height: normal;">
          点击停止录音
        </div>
      </div>


      <!-- <P class="localUrl-block" v-if="recBlob">{{ localUrl
      }}<i class="el-icon-error localUrl-block-icon" @click="recClear"></i></P> -->

      <P class="localUrl-block" v-if="recBlob">音频文件<i class="el-icon-error localUrl-block-icon" @click="recClear"></i></P>
      <!-- <div style="padding-top: 5px" :style="{
        opacity: waveBlock ? 1 : 0,
      }"> -->
      <!-- 波形绘制区域 -->
      <!-- <div style="
          border: 1px solid #ccc;
          display: inline-block;
          vertical-align: bottom;
        ">
          <div style="height: 100px; width: 300px" ref="recwave"></div>
        </div> -->
      <!-- </div> -->
      <div v-if="audio" style="margin-top: 10px;">
        <audio controls ref="audio" class="aud" controlsList="nodownload noplaybackrate">
          <source :src="audio" />
        </audio>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVie">取 消</el-button>
        <el-button type="primary" @click="clickDialog">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Recorder from "recorder-core";
import { uploadAudio } from '@/api/ActivitySetting'
import "recorder-core/src/engine/mp3";
import "recorder-core/src/engine/mp3-engine";
import "recorder-core/src/extensions/waveview";
export default {
  name: "AdminPcIndex",

  data() {
    return {
      rec: null,
      recBlob: null,
      wave: null,
      waveBlock: false,
      localUrl: "",
      dialogVisible: false,
      dielfds: true,
      audio: ''
    };
  },

  mounted() {
    console.log(this.$refs, 'audio=============refs')
  },

  methods: {
    // 点击左上角x
    handleClose() {
      if (this.audio == '') {
        this.dialogVisible = false
      } else {
        this.$emit('clickRecStop', 1)
      }
    },
    // 取消
    dialogVie() {
      if (this.audio == '') {
        this.dialogVisible = false
      } else {
        this.$emit('clickRecStop', 1)
      }
      // this.recStop()
      // // this.$emit('clickRecStop',this.audio)
      // this.dialogVisible = false
    },
    clickDialog() {
      if (this.dielfds == false) {
        this.$message.warning("请先暂停录音");
        return
      }
      if (this.audio == '') {
        this.dialogVisible = false
      } else {
        this.rec = null,
          this.$emit('clickRecStop', 2)
      }

      // this.dialogVisible = false
    },
    // ==============录音 start
    recClear() {
      if (this.localUrl) {
        // this.rec = null;
        this.recBlob = null;
        this.waveBlock = false;
        this.audio = ''
        this.localUrl = "";
        this.$emit('clickRecClear')
      } else {
        this.$message.warning("请先录音");
      }
    },
    recPlay() {
      if (!this.recBlob) {
        this.$message.warning("请先录音");
        return;
      }
      //本地播放录音试听，可以直接用URL把blob转换成本地播放地址，用audio进行播放
      var localUrl = URL.createObjectURL(this.recBlob);
      var audio = document.createElement("audio");
      audio.controls = true;
      document.body.appendChild(audio);
      audio.src = localUrl;
      audio.play(); //这样就能播放了

      //注意不用了时需要revokeObjectURL，否则霸占内存
      setTimeout(function () {
        URL.revokeObjectURL(audio.src);
      }, 5000);
    },
    blobToFile(blob, fileName) {
      return new File([blob], fileName);
    },
    upload(blob) {
      let self = this
      //使用FormData用multipart/form-data表单上传文件
      //或者将blob文件用FileReader转成base64纯文本编码，使用普通application/x-www-form-urlencoded表单上传
      let file = this.blobToFile(blob, 'fileName')
      var form = new FormData();
      form.append("file", blob, "recorder.mp3"); //和普通form表单并无二致，后端接收到upfile参数的文件，文件名为recorder.mp3
      // form.append("key", "value"); //其他参数
      uploadAudio(form).then((res) => {
        if (res.code == 20000) {
          self.audio = res.data
          self.$nextTick(() => {
            self.$refs.audio.src = res.data
            console.log(self.$refs, res.data,self.audio, 'this.audio==========111')
          })
        }
      })
      // var xhr = new XMLHttpRequest();
      // console.log(xhr, "xhrxhr上传成功");
      // xhr.open("POST", "/api/sw-api/upload/common/uploadAudio");
      // xhr.onreadystatechange = () => {
      //   console.log(xhr, "readyStatereadyState上传成功");
      //   if (xhr.readyState == 4) {
      //     if (xhr.status == 200) {
      //       console.log("上传成功");
      //     } else {
      //       console.error("上传失败" + xhr.status);
      //     }
      //   }
      // };
      // xhr.send(form);
    },
    recStop() {
      if (!this.rec) {
        console.error("未打开录音");
        this.$message.warning("未打开录音");
        return;
      }
      this.rec.stop(
        (blob, duration) => {
          this.dielfds = !this.dielfds
          console.log("blob, duration", blob, duration);
          //blob就是我们要的录音文件对象，可以上传，或者本地播放
          this.recBlob = blob;
          //简单利用URL生成本地文件地址，此地址只能本地使用，比如赋值给audio.src进行播放，赋值给a.href然后a.click()进行下载（a需提供download="xxx.mp3"属性）
          var localUrl = (window.URL || webkitURL).createObjectURL(blob);
          console.log("录音成功", blob, localUrl, "时长:" + duration + "ms");
          console.log(localUrl.split("/"));
          if (localUrl) {
            this.localUrl = localUrl.split("/")[localUrl.split("/").length - 1];
          }

          this.upload(blob); //把blob文件上传到服务器

          // this.rec.close(); //关闭录音，释放录音资源，当然可以不释放，后面可以连续调用start
          // this.rec = null;
          console.log(this.audio, 'this.audio=============')
          this.waveBlock = false;
        },
        (err) => {
          console.error("结束录音出错：" + err);
          this.rec.close(); //关闭录音，释放录音资源，当然可以不释放，后面可以连续调用start
          this.rec = null;
          this.waveBlock = false;
        }
      );
    },
    recStart() {

      if (!this.rec) {
        console.error("未打开录音");
        this.$message.warning("未打开录音");
        return;
      }
      this.rec.start();
      console.log("已开始录音");
      this.$message.success("已开始录音");
      this.dielfds = !this.dielfds
      this.waveBlock = true;
    },
    recOpen() {
      //创建录音对象
      this.rec = Recorder({
        type: "mp3", //录音格式，可以换成wav等其他格式
        sampleRate: 16000, //录音的采样率，越大细节越丰富越细腻
        bitRate: 16, //录音的比特率，越大音质越好
        onProcess: (
          buffers,
          powerLevel,
          bufferDuration,
          bufferSampleRate,
          newBufferIdx,
          asyncEnd
        ) => {
          //录音实时回调，大约1秒调用12次本回调
          //可实时绘制波形，实时上传（发送）数据
          if (this.wave)
            this.wave.input(
              buffers[buffers.length - 1],
              powerLevel,
              bufferSampleRate
            );
        },
      });
      //打开录音，获得权限
      this.rec.open(
        () => {
          console.log("录音已打开");
          this.$message.success("录音已打开");
          this.dialogVisible = true
          if (this.$refs.recwave) {
            //创建音频可视化图形绘制对象
            this.wave = Recorder.WaveView({ elem: this.$refs.recwave });
          }
        },
        (msg, isUserNotAllow) => {
          //用户拒绝了录音权限，或者浏览器不支持录音
          console.log(
            (isUserNotAllow ? "UserNotAllow，" : "") + "无法录音:" + msg
          );
          this.$message.warning(
            (isUserNotAllow ? "UserNotAllow，" : "") + '使用录音功能请安装麦克风'
          );
          this.rec = null;
          this.waveBlock = false;
        }
      );
    },
    // ==============录音 end
  },
};
</script>

<style lang="scss" scoped>
.localUrl-block {
  border: 1px dotted #acacac;
  border-radius: 10px;
  padding: 5px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 25px;

  &-icon {
    font-size: 26px;
    margin-left: 20px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/soundRecording/index.vue